import {
  canEditMemberPermissions,
  canViewMemberDetailsPermissions,
} from '../../../../../config/accessPolicies/accessPolicies';
import EditMemberModal from '../../../../../styledComponents/Modals/EditMemberModal/EditMemberModal';
import GeneralMembersList from '../../../../../styledComponents/ProductMembersList/GeneralMembersList/GeneralMembersList';
import { useMembersGeneral } from './generalMembers.hooks';

const GeneralMembers = () => {
  const {
    onRowClickHandler,
    personGeneralList,
    personListLoading,
    rowEditHandler,
    loadGeneralPersonListHandler,
  } = useMembersGeneral();

  return (
    <>
      <EditMemberModal onMemberEdited={loadGeneralPersonListHandler} />
      <GeneralMembersList
        tableProps={{
          data: personGeneralList,
          isLoading: personListLoading,
          onRowClick: onRowClickHandler,
          onRowEdit: rowEditHandler,
          canViewDetailsPermissions: canViewMemberDetailsPermissions,
          canEditPermissions: canEditMemberPermissions,
        }}
      />
    </>
  );
};

export default GeneralMembers;
